import { render, staticRenderFns } from "./subsidy_details.vue?vue&type=template&id=efe356f2&scoped=true&"
import script from "./subsidy_details.vue?vue&type=script&lang=js&"
export * from "./subsidy_details.vue?vue&type=script&lang=js&"
import style0 from "./subsidy_details.vue?vue&type=style&index=0&id=efe356f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe356f2",
  null
  
)

export default component.exports